import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconMp4SizeM from './FileIconMp4_size_m';
import FileIconMp4SizeS from './FileIconMp4_size_s';

export const FileIconMp4 = createFileIcon({
  m: FileIconMp4SizeM,
  s: FileIconMp4SizeS,
  name: 'FileIconMp4',
});
